import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface LangState {
  currentLanguage: string
  availableLanguages: string[]
  isLoading: boolean
}

const initialState: LangState = {
  currentLanguage: 'en',
  availableLanguages: ['en', 'tr'],
  isLoading: false,
}

const langSlice = createSlice({
  name: 'lang',
  initialState,
  reducers: {
    setCurrentLanguage: (state, action: PayloadAction<string>) => {
      state.currentLanguage = action.payload
    },
    setLanguageLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    addAvailableLanguage: (state, action: PayloadAction<string>) => {
      if (!state.availableLanguages.includes(action.payload)) {
        state.availableLanguages.push(action.payload)
      }
    },
  },
})

export const {
  setCurrentLanguage,
  setLanguageLoading,
  addAvailableLanguage,
} = langSlice.actions

export default langSlice.reducer 